import React from 'react';
import { SvgIcon } from '@mui/material';

import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import MonitorIcon from '@mui/icons-material/Monitor';
import DnsIcon from '@mui/icons-material/Dns';
import DatasetOutlinedIcon from '@mui/icons-material/DatasetOutlined';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ScienceIcon from '@mui/icons-material/Science';

import ViewListIcon from '@mui/icons-material/ViewList';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import BadgeIcon from '@mui/icons-material/Badge';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EventIcon from '@mui/icons-material/Event';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import BuildIcon from '@mui/icons-material/Build';
import WarningIcon from '@mui/icons-material/Warning';
import SchemaIcon from '@mui/icons-material/Schema';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DownloadIcon from '@mui/icons-material/Download';
import DesktopMacRoundedIcon from '@mui/icons-material/DesktopMacRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PersonPinCircleRoundedIcon from '@mui/icons-material/PersonPinCircleRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import GridViewIcon from '@mui/icons-material/GridView';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

function ServiceIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path d="M28 18h-6a2.002 2.002 0 0 0-2 2v2h-5.586L10 17.586V12h2a2.002 2.002 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2H6a2.002 2.002 0 0 0-2 2v6a2.002 2.002 0 0 0 2 2h2v5.586l-4.707 4.707a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414 0L14.414 24H20v2a2.002 2.002 0 0 0 2 2h6a2.002 2.002 0 0 0 2-2v-6a2.002 2.002 0 0 0-2-2zM6 4h6v6H6zm3 22.586L5.414 23 9 19.414 12.586 23zM22 26v-6h6v6z" />
      </svg>
    </SvgIcon>
  );
}

function VendorIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path d="M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z" />
        <path d="M18 8H20V10H18zM24 8H26V10H24zM18 14H20V16H18zM24 14H26V16H24zM18 20H20V22H18zM24 20H26V22H24z" />
      </svg>
    </SvgIcon>
  );
}

export const Icons = {
  SINGLE_PORTFOLIO: MenuBookRoundedIcon,
  SINGLE_APPLICATION: MonitorIcon,
  SINGLE_COMPONENT: DnsIcon,
  SINGLE_CAPABILITY: DatasetOutlinedIcon,
  SINGLE_BUSINESS: BusinessCenterIcon,
  SINGLE_TECHNOLOGY: ScienceIcon,
  SINGLE_SERVICE: ServiceIcon,
  ROSTER: ViewListIcon,
  TEAM: GroupsRoundedIcon,
  ROLE: BadgeIcon,
  SERVICE: SchemaIcon,
  VENDOR: VendorIcon,
  SEARCH: SearchIcon,
  EDIT: EditIcon,
  EDIT_OUTLINED: EditOutlinedIcon,
  CALENDAR: EventIcon,
  GROUP: GroupIcon,
  PERSON: PersonIcon,
  NO_PERSON: PersonOffIcon,
  ACCOUNT: AccountCircleIcon,
  ROCKET_LAUNCH: RocketLaunchIcon,
  BUILD: BuildIcon,
  WARNING: WarningIcon,
  CLOSE_ICON: CloseIcon,
  CLOSE_ROUNDED_ICON: CloseRoundedIcon,
  COPY: ContentCopyIcon,
  ADD: AddIcon,
  MORE: MoreVertIcon,
  ERROR: HighlightOffIcon,
  CLOCK: WatchLaterOutlinedIcon,
  DOWNLOAD: DownloadIcon,
  DOTS: MoreVertIcon,
  TECHNOLOGY_AND_SKILLS: DesktopMacRoundedIcon,
  GRID_VIEW: GridViewIcon,
  CAPABILITIES: FormatListBulletedIcon,
  LOCK: LockRoundedIcon,
  LOCK_OUTLINED: LockOutlinedIcon,
  PERSON_LOCATION: PersonPinCircleRoundedIcon,
  INFO: HelpOutlineRoundedIcon,
  ADD_PERSON: PersonAddAltRoundedIcon,
  OPEN_LINK_ICON: OpenInNewIcon,
  SETTINGS: SettingsRoundedIcon,
  DOLLAR: AttachMoneyIcon,
};
